<template>
  <v-card class="ma-6 profileview">
    <v-row class="my-profile pb-10">
      <v-col cols="3">
        <div class="profilepic">
          <img src="../../assets/img/ProfilePicture.png" />
        </div>
        <p class="font-weight-medium text-uppercase username black--text"
          >{{ user.first_name + ' ' + user.last_name }}
        </p>
        <p class="font-weight-regular body-2 black--text mailbox">
          <v-icon>email</v-icon>
          {{ getUser.email }}
        </p>
        <v-divider class="customborder"></v-divider>
        <p class="font-weight-medium text-uppercase body-2 black--text mt-4"
          >User Settings
        </p>
        <v-btn text block class="action-btns" @click="enableEdit()">
          <v-icon class="pr-2">edit</v-icon>
          Edit Details
        </v-btn>
        <v-btn
          @click="$router.push({ name: 'changePassword' })"
          text
          block
          class="action-btns"
        >
          <v-icon class="pr-2">lock</v-icon>
          Reset Password
        </v-btn>
      </v-col>
      <v-col cols="9">
        <div class="profilebg pa-6">
          <div class="headding">
            <div class="iconbg">
              <v-icon>person</v-icon>
            </div>
            <span class="font-weight-medium">Personal Details</span>
            <v-divider></v-divider>
          </div>
          <div class="fileds">
            <v-form v-model="isValid">
            <v-row>
          
              <v-col cols="4">
                <p
                  class="font-weight-medium subtitle-2 text-uppercase"
                  for="name"
                  >First Name</p
                >
                <p
                  class="font-weight-regular subtitle-2"
                  v-if="isEdit === false"
                  >{{ user.first_name }}</p
                >
                <v-text-field
                  :rules="firstnameRules"
                  v-if="isEdit === true"
                  v-model="userObject.first_name"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <p class="font-weight-medium subtitle-2 text-uppercase"
                  >Last Name</p
                >
                <p
                  class="font-weight-regular subtitle-2"
                  v-if="isEdit === false"
                  >{{ user.last_name }}</p
                >
                <v-text-field
                  :rules="lastnameRules"
                  v-if="isEdit === true"
                  v-model="userObject.last_name"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <p class="font-weight-medium subtitle-2 text-uppercase"
                  >Email</p
                >
                <p
                  class="font-weight-regular subtitle-2"
                  v-if="isEdit === false"
                  >{{ getUser.email }}</p
                >
                <v-text-field
                  v-if="isEdit === true"
                  v-model="getUser.email"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <p class="font-weight-medium subtitle-2 text-uppercase">Role</p>
                <p
                  class="font-weight-regular subtitle-2"
                  v-if="isEdit === false"
                  >{{ user.role_name }}</p
                >

                <v-select
                  v-if="isEdit === true"
                  v-model="user.role_name"
                  disabled
                  :items="roles"
                  :item-value="(item) => item.role_name"
                  :item-text="(item) => item.role_name"
                  :menu-props="{ top: true, offsetY: true }"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <p class="font-weight-medium subtitle-2 text-uppercase"
                  >Phone Number</p
                >
                <p
                  class="font-weight-regular subtitle-2"
                  v-if="isEdit === false"
                  >{{ user.phoneNumber }}</p
                >
                <v-text-field
                  class="inputtype"
                  :rules="phonenumberRules"
                  v-model="userObject.phoneNumber"
                  v-if="isEdit === true"
                  @keydown="updated($event)"
                  @keypress="isNumber($event)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn
                  depressed
                  class="primary_btn small mr-4"
                  v-if="isEdit === true"
                  @click="update()"
                  :disabled="!isValid"
                  >Save</v-btn
                >
                <v-btn
                  depressed
                  class="secondary_btn small"
                  v-if="isEdit === true"
                  @click="
                    isEdit = false;
                    getCurrentUser();
                  "
                  >Cancel</v-btn
                >
              </v-col>
            </v-row>
            </v-form>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { storeActions } from '../../store/actions.constants';
export default {
  data() {
    return {
      isValid:true,
      userObject: {
        first_name: '',
        last_name: '',
        email: '',
        role: '',
        phoneNumber: '',
      },

      roles: [],
      isEdit: false,
      userDetails: {},
      invalidChars: ['-', '+', 'e', '.'],
      firstnameRules: [
        (v) => !!v || 'First Name required',
        (v) =>
          (v.length >= 3 && v.length <= 30) ||
          'First Name must be between 3 to 30 characters long.',
      ],
      lastnameRules: [
        (v) => !!v || 'Last Name required',
        (v) =>
          (v.length >= 1 && v.length <= 30) ||
          'Last Name must be between 1 to 30 characters long.',
      ],
      phonenumberRules: [
        (v) => !!v || 'Phone Number required',
        (v) =>
          (v.length >= 8 && v.length <= 15) ||
          'Phone Number must be between 8 to 15 characters long.',
      ],
    };
  },
 
  computed: {
    ...mapGetters({
      user: 'users/getCurrentUser',
      getUser: 'users/getUser',
    }),
  },
  async mounted() {
    await this.fetchCurrentUser();
    await this.getRoles().then((res) => {
      this.roles = res.data;
    });
   //this.userObject = this.user;
  this.userObject.first_name=this.user.first_name
  this.userObject.last_name=this.user.last_name
  this.userObject.phoneNumber=this.user.phoneNumber
  },
  methods: {
    async update() {
     // console.log(this.userObject);
      this.userDetails = await this.updateUser({
        phoneNumber: this.userObject.phoneNumber.trim(),
        first_name: this.userObject.first_name.trim(),
        last_name: this.userObject.last_name.trim(),
      });
      if (this.userDetails.status === 200) {
        
        await this.fetchCurrentUser();

        this.userObject.first_name=this.user.first_name;
        this.userObject.last_name=this.user.last_name;
        this.userObject.phoneNumber=this.user.phoneNumber
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
                text: this.userDetails.data.message,
                timeout: 3000,
                color: 'success',
              });
        this.isEdit = false;
      }
      else{
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
                text: this.userDetails.data.message,
                timeout: 3000,
                color: 'error',
              });
      }
      //console.log(this.user);
    },
    ...mapActions({
      fetchCurrentUser: 'users/getCurrentUserDetails',
      getRoles: 'addLicenseManager/getRoleList',
      updateUser: 'users/updateCurrentUserDetails',
    }),
    updated(val) {
      if (this.invalidChars.includes(val.key)) val.preventDefault();
    },
    getCurrentUser() {
      this.fetchCurrentUser();
    },
    enableEdit(){
      this.userObject.first_name=this.user.first_name
      this.userObject.last_name=this.user.last_name
      this.userObject.phoneNumber=this.user.phoneNumber
      this.isEdit=true;
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    
  },
};
</script>

<style lang="scss" scoped>
.profileview {
  box-shadow: none;
  .username {
    font-size: 20px;
  }
  .mailbox {
    i {
      padding-right: 10px;
      color: #000;
    }
  }
  .action-btns {
    padding: 0px;
    justify-content: left;
  }
  .customborder {
    border-style: dashed;
    border-color: #bdbdbd;
  }
  .profilepic {
    width: 100%;
    margin-bottom: 10px;
    img {
      width: 100%;
    }
  }
  .profilebg {
    background-color: rgba(231, 233, 238, 0.3);
    min-height: 500px;
    .headding {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .iconbg {
        width: 50px;
        height: 50px;
        background: #e8eef9;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 24px;
        }
      }
      span {
        padding: 0px 10px 0px 15px;
      }
    }
  }
}
.my-profile {
  &__img {
    max-width: 160px;
  }
  &__cont {
    padding-left: 32px;
    span {
      display: block;
      margin-bottom: 5px;
    }
    .v-input {
      max-width: 350px;
      margin-bottom: 15px;
    }
  }
  &__name {
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
<style scoped>
.inputtype input[type='number'] {
  -moz-appearance: textfield;
}
</style>